import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { logger } from "../lib/logger";
import { useVerticalNav } from "./useVerticalNav";

const FEED_CHANNEL = { name: "Pour toi", category: "FYP · Mélange", color: "#f0b429", slug: "fyp" };

const fetchShorts = (channelId) => {
  if (!channelId) {
    return api.get("/shorts/feed?limit=40").then(r => ({ channel: FEED_CHANNEL, videos: r.data.videos || [] }));
  }
  return api.get(`/schedule/${channelId}`).then(r => ({ channel: r.data.channel, videos: r.data.playlist || [] }));
};

/** Data + navigation state for the vertical Shorts player. */
export const useShortsFeed = (channelId) => {
  const key = channelId || "feed";
  const [channel, setChannel] = useState(null);
  const [videos, setVideos] = useState([]);
  const [index, setIndex] = useState(0);
  const [muted, setMuted] = useState(true);
  const [loadedKey, setLoadedKey] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchShorts(channelId)
      .then(({ channel: c, videos: v }) => {
        if (cancelled) return;
        setChannel(c);
        setVideos(v);
        setIndex(0);
      })
      .catch(err => logger.warn("[shorts] load failed:", err))
      .finally(() => { if (!cancelled) setLoadedKey(key); });
    return () => { cancelled = true; };
  }, [channelId, key]);

  const next = useCallback(() => setIndex(i => Math.min(videos.length - 1, i + 1)), [videos.length]);
  const prev = useCallback(() => setIndex(i => Math.max(0, i - 1)), []);
  const toggleMuted = useCallback(() => setMuted(m => !m), []);
  const gestures = useVerticalNav({ next, prev, onMuteKey: toggleMuted });

  return {
    loading: loadedKey !== key,
    channel, videos, index, current: videos[index],
    muted, toggleMuted, next, prev, gestures,
  };
};
